import {Component, Input, OnInit} from '@angular/core';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {EDITION_BUNDLE_TYPE, EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpConfigService} from '@app/services/dcp-config.service';
import {DcpOrderEntryService} from '@app/services/dcp-order-entry.service';
import {DcpEntryGroup, FeatureTogglesService} from '@dcp/configurator';
import {Cart} from '@spartacus/cart/base/root';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {Observable, combineLatest} from 'rxjs';
import {map} from 'rxjs/operators';
import {ContractPriceService} from '../services/contract-price.service';

@Component({
  selector: 'dcp-recurring-total',
  styleUrl: 'recurring-total.component.scss',
  templateUrl: './recurring-total.component.html'
})
export class RecurringTotalComponent implements OnInit {
  @Input() providerContract: DcpEntryGroup;
  @Input() checkout$: Observable<Cart>;

  showRecurringTotal$: Observable<boolean>;
  duration: number;
  recurringTotal$: Observable<string>;

  constructor(
    private entryGroupService: EntryGroupService,
    private configService: DcpConfigService,
    private orderEntryService: DcpOrderEntryService,
    private featureToggleService: FeatureTogglesService,
    private contractPriceService: ContractPriceService
  ) {
  }

  ngOnInit(): void {
    const entry = this.entryGroupService.getFirstEntry(this.providerContract.entryGroups, EDITION_BUNDLE_TYPE);
    if (entry) {
      this.showRecurringTotal$ = this.getShowRecurringTotal(entry);
      this.duration = this.getDuration(entry);
      this.recurringTotal$ = this.contractPriceService.getSplitGroupTotal('recurring', entry, this.checkout$);
    }
  }

  private getShowRecurringTotal(entry: OrderEntry): Observable<boolean> {
    return combineLatest([
      this.featureToggleService.isEnabled(UNLEASH_TOGGLES.showRecurringTotal),
      this.configService.getCommercialModelConfig(entry.product, entry.transactionType)
    ]).pipe(map(([toggle, config]) => toggle && config.showRecurringTotal));
  }

  private getDuration(entry: OrderEntry): number {
    return Number(this.orderEntryService.getConfiguration(entry).duration.value);
  }
}
